import type { SocialCaptions } from 'bundles/sharing-common/types/sharingSharedTypes';

import _t from 'i18n!nls/collections';

export default (): SocialCaptions => {
  return {
    twitter: () => _t('Learn new skills with this curated collection of courses from @Coursera.'),
    whatsapp: (shareLink) =>
      _t(
        "I think you'll love this curated collection of courses from Coursera. The courses are 100% online and you can learn on your own schedule. Get started today #{shareLink}",
        {
          shareLink,
        }
      ),
    emailSubject: () => _t('Check out this curated collection of courses from Coursera!'),
    emailBody: (shareLink) =>
      _t(
        'I thought you might like this curated collection of courses from Coursera #{shareLink}.\n\n' +
          'With Coursera, you can take online courses created by leading universities and companies like Yale, Google, the University of Michigan, and much more.\n\n' +
          'Let me know what you think!',
        {
          shareLink,
        }
      ),
  };
};
